export default [{
  name: 'dataMonitor',
  path: '/dataMonitor',
  component: () => import('./DataMonitor.vue'),
  mode: 'hash',
  meta: {
    title: '数据可视化大屏'
  }
}]



// WEBPACK FOOTER //
// ./src/router/data_monitor/index.js